import React from 'react';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row, Input, FormText
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';
import OutstandingAirlinesList from "./outstandling-airlines-list";
import DownloadIcon from 'react-icons/lib/md/cloud-download';

const ProformaFilterPanel = ({ reportsLength, showOutstandingAirlines, requesting, passedMainSelection, removeOutstandingAirline, outstandingAirlines, handleSelectChange, handleChange, airports, onSearch, SourceAirportId, ROE, componentErrorMessages, toggleOutstandingAirlines, handleReportDownload, isVGGUser }) => {
    return (
        <div>
            <Form onSubmit={e => e.preventDefault()}>
                <Container>
                    <Row>
                        <Col xs="6" sm="3">
                            <FormGroup className={"mb-3 " + (componentErrorMessages.FlightStartDate ? 'has-danger' : '')}>
                                <Label>Start Date</Label>
                                <DateSelector dayNotAllowed={true} maxDate={new Date()} todayDate={(new Date()).toString()} name="startDate" onValueChange={(event) => handleChange(event, 'FlightStartDate')} />
                            </FormGroup>
                        </Col>
                        <Col xs="6" sm="3">
                            <FormGroup className={"mb-0 " + (componentErrorMessages.FlightEndDate ? 'has-danger' : '')}>
                                <Label>End Date</Label>
                                <DateSelector dayNotAllowed={true} maxDate={new Date()} todayDate={(new Date()).toString()} name="endDate" onValueChange={(event) => handleChange(event, 'FlightEndDate')} />
                            </FormGroup>
                        </Col>

                        <Col xs="6" sm="4">
                            <FormGroup className={"mb-0 " + (componentErrorMessages.SourceAirportId ? 'has-danger' : '')}>
                                <Label>Station</Label>
                                <SelectListComponent placeholder={'Select airport...'} data={airports} valueKey='Id' textField='Name' selectValue={SourceAirportId} onValueChange={(event) => { handleSelectChange(event, 'SourceAirportId') }} />
                                {componentErrorMessages.SourceAirportId && <FormText color="danger"> {componentErrorMessages.SourceAirportId}</FormText>}
                            </FormGroup>
                        </Col>
                        <Col xs="6" sm="2">
                            <FormGroup className={"mb-0 " + (componentErrorMessages.ROE ? 'has-danger' : '')}>
                                <Label>ROE</Label>
                                <Input type="text" placeholder="Rate of Exchange" value={ROE} onChange={(event) => handleChange(event.target.value, 'ROE')} />
                                {componentErrorMessages.ROE && <FormText color="danger"> {componentErrorMessages.ROE}</FormText>}
                            </FormGroup>
                        </Col>
                        <Col xs="6" sm="3">
                            <FormGroup className="mt-1">
                                <Button disabled={requesting} className="btn-avi-primary pl-4 pr-4" onClick={(event) => onSearch(null)}>Search</Button> &nbsp;
                            { (!isVGGUser) && <Button disabled={!passedMainSelection || requesting || (reportsLength === 0)} className="btn-avi-secondary" onClick={(event) => toggleOutstandingAirlines(event)}>
                                    {
                                       (showOutstandingAirlines) &&
                                        <span>Hide Outstanding</span>
                                    }
                                    {
                                        (!showOutstandingAirlines) &&
                                        <span>Add Outstanding</span>
                                    }
                            </Button> }
                                <div className="clearfix">&nbsp;</div>
                            </FormGroup>
                        </Col>
                        <Col xs={12} sm={"9"}>
                            {
                                reportsLength > 0 &&
                                <div style={{ textAlign: 'right' }}>
                                    <Button disabled={requesting} className="btn btn-avi-secondary pl-4 pr-4" onClick={handleReportDownload}>
                                        <DownloadIcon /> Download
                                </Button> &nbsp;
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>

            </Form>

            <div className='col-sm-12'>
                <OutstandingAirlinesList removeOutstandingAirline={removeOutstandingAirline} data={outstandingAirlines} />
            </div>

        </div>
    )
};
export default ProformaFilterPanel;



// WEBPACK FOOTER //
// ./src/views/proforma/filter-panel.js